module.exports = __webpack_public_path__ + "img/violin.be5030ca.webp";